(function () {

  function formatMoney(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
      minimumFractionDigits: 2,
    }).format(amount);
  }
  const CART_ICON  = `<svg width="24" height="19" viewBox="0 0 24 19" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.76238 5.86742C2.76238 5.61516 2.88264 5.28164 3.29652 4.87958C3.71346 4.47454 4.36842 4.06414 5.25848 3.69842C7.03385 2.96894 9.55493 2.4948 12.3907 2.4948C15.2264 2.4948 17.7475 2.96894 19.5228 3.69842C20.4129 4.06414 21.0679 4.47454 21.4848 4.87958C21.8987 5.28164 22.0189 5.61516 22.0189 5.86742C22.0189 6.21623 21.7739 6.73849 20.8873 7.32947C20.0274 7.90265 18.7372 8.41283 17.1226 8.76225L16.5834 8.87893L16.4589 9.2294L16.4478 9.22558L16.0922 10.2615L15.9782 10.5824L15.9816 10.5836L15.4683 12.0787H9.3031L8.90483 10.9669L8.91308 10.9641L8.3874 9.41254L8.2073 8.88096L7.65874 8.76225C6.04415 8.41283 4.75388 7.90265 3.89401 7.32947C3.00746 6.73849 2.76238 6.21623 2.76238 5.86742ZM6.65568 10.5628C5.3603 10.2402 4.19979 9.80382 3.26127 9.26581C3.37329 9.82509 3.50177 10.4089 3.64687 10.9965C4.08027 12.7515 4.64085 14.4501 5.30705 15.6326C6.80461 16.0089 9.75065 16.4988 12.391 16.5049C15.0313 16.4988 17.9773 16.0089 19.4749 15.6326C20.1411 14.4501 20.7016 12.7515 21.135 10.9965C21.2802 10.4088 21.4087 9.82482 21.5207 9.26542C20.572 9.80938 19.3964 10.2495 18.0839 10.5731L17.9625 10.9147L17.1125 13.3909L16.8829 14.0599H16.1756H8.60573H7.90836L7.67318 13.4033L6.65568 10.5628ZM24.0001 5.86742C24.0001 6.03013 23.9865 6.18857 23.9606 6.34271L23.9943 6.34655C23.8586 7.54103 23.5493 9.48366 23.0584 11.4715C22.5735 13.4349 21.8862 15.55 20.9551 17.0165L20.7536 17.3338L20.3924 17.4376C19.0305 17.829 16.0333 18.3792 13.1595 18.4723L13.1596 18.4744C12.9066 18.4828 12.65 18.4865 12.391 18.4859C12.1319 18.4865 11.8753 18.4828 11.6223 18.4744L11.6224 18.4723C8.74864 18.3792 5.7514 17.829 4.38951 17.4376L4.02829 17.3338L3.82684 17.0165C2.89571 15.55 2.2084 13.4349 1.72352 11.4715C1.23262 9.48366 0.92332 7.54103 0.787584 6.34655L0.820764 6.34278C0.794853 6.18862 0.78125 6.03015 0.78125 5.86742C0.78125 4.91483 1.25527 4.10052 1.91608 3.45857C2.57382 2.81961 3.47395 2.28982 4.50553 1.86595C6.57342 1.01627 9.36176 0.513672 12.3907 0.513672C15.4196 0.513672 18.2079 1.01627 20.2758 1.86595C21.3074 2.28982 22.2075 2.81961 22.8652 3.45857C23.526 4.10052 24.0001 4.91483 24.0001 5.86742Z" fill="currentColor"></path></svg>`;
  const PLUS_ICON  = `<svg viewBox="0 0 24 24" aria-hidden="true" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>`;
  const CHECK_ICON = `<svg viewBox="0 0 24 24" aria-hidden="true" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"><polyline points="20 6 9 17 4 12"/></svg>`;
  const SPINNER    = `<div class="cart-upsell__spinner"></div>`;
  const ARROW_PREV = `<svg viewBox="0 0 24 24" aria-hidden="true" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"><polyline points="15 18 9 12 15 6"/></svg>`;
  const ARROW_NEXT = `<svg viewBox="0 0 24 24" aria-hidden="true" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"><polyline points="9 18 15 12 9 6"/></svg>`;

  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function getProductPrice(product) {
    if (product.variants && product.variants.length > 0) {
      return { price: product.variants[0].price, compare_at_price: product.variants[0].compare_at_price, variant_id: product.variants[0].id };
    }
    return { price: product.price_min || product.price || 0, compare_at_price: product.compare_at_price_min || null, variant_id: null };
  }

  function injectStyles() {
    if (document.getElementById('cart-upsell-styles')) return;
    const style = document.createElement('style');
    style.id = 'cart-upsell-styles';
    style.textContent = `
      .cart-upsell { width:100%; padding-block:var(--padding-lg); border-block-start:1px solid var(--color-border); }
      .cart-upsell.hidden { display:none; }

      /* Title row with arrows */
      .cart-upsell__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: var(--margin-sm);
      }
      .cart-upsell__title {
        font-size: 15px;
        font-weight: var(--font-weight-bold);
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: rgb(var(--color-foreground-rgb) / var(--opacity-subdued-text));
        margin: 0;
      }
      .cart-upsell__arrows {
        display: flex;
        gap: 4px;
      }
      .cart-upsell__arrow {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 50%;
        border: 1.5px solid var(--color-border);
        background: transparent;
        color: var(--color-foreground);
        cursor: pointer;
        padding: 0;
        transition: background 0.15s, border-color 0.15s, opacity 0.15s;
      }
      .cart-upsell__arrow:hover { background: rgb(var(--color-foreground-rgb) / 0.06); }
      .cart-upsell__arrow:disabled { opacity: 0.3; cursor: default; pointer-events: none; }
      .cart-upsell__arrow svg { width: 0.85rem; height: 0.85rem; display: block; }

      /* Swiper */
      .cart-upsell__swiper { overflow: hidden; width: 100%; cursor: grab; }
      .cart-upsell__swiper:active { cursor: grabbing; }
      .cart-upsell__swiper-wrapper {
        display: flex;
        transition: transform 0.32s cubic-bezier(0.25,0.46,0.45,0.94);
        will-change: transform;
        user-select: none;
      }
      .cart-upsell__slide { flex: 0 0 70%; width: 70%; padding-right: 10px; box-sizing: border-box; }

      .cart-upsell__item {
        display: flex; align-items: center; gap: var(--gap-md);
        padding: var(--padding-sm);
        border-radius: var(--style-border-radius-cards, 8px);
        background-color: rgb(var(--color-background-rgb) / 0.5);
        border: 1px solid var(--color-border);
        box-sizing: border-box;
      }
        .cart-drawer__content{
          mask-image: none !important;
        }
      .cart-upsell__image-link { flex-shrink:0; display:block; width:3.5rem; height:3.5rem; border-radius:calc(var(--style-border-radius-cards,8px) - 2px); overflow:hidden; text-decoration:none; }
      .cart-upsell__image { width:100%; height:100%; object-fit:cover; object-position:center; }
      .cart-upsell__image--placeholder { width:100%; height:100%; background-color:var(--color-border); }
      .cart-upsell__details { flex:1; min-width:0; }
      .cart-upsell__name { font-size:15px; font-weight:400; color:var(--color-foreground); text-decoration:none; display:block; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; margin-block-end:var(--margin-3xs); }
      .cart-upsell__name:hover { opacity:0.8; }
      .cart-upsell__price-row { display:flex; align-items:center; gap:var(--gap-xs); }
      .cart-upsell__price { font-size:var(--font-size--sm); color:rgb(var(--color-foreground-rgb)/var(--opacity-subdued-text)); }
      .cart-upsell__compare-price { font-size:var(--font-size--xs); color:rgb(var(--color-foreground-rgb)/var(--opacity-subdued-text)); text-decoration:line-through; }
      .cart-upsell__add-btn { flex-shrink:0; display:flex; align-items:center; justify-content:center; width:2rem; height:2rem; border-radius:50%; background-color:var(--color-button); color:var(--color-button-text); border:none; cursor:pointer; transition:opacity 0.2s,transform 0.15s; padding:0; text-decoration:none; }
      .cart-upsell__add-btn:hover { opacity:0.85; transform:scale(1.08); }
      .cart-upsell__add-btn:active { transform:scale(0.95); }
      .cart-upsell__add-btn.loading { pointer-events:none; opacity:0.6; }
      .cart-upsell__add-btn.added { background-color:#2d7a3a; pointer-events:none; }
      .cart-upsell__add-btn svg { width:1rem; height:1rem; display:block; }
      .cart-upsell__spinner { width:0.875rem; height:0.875rem; border:2px solid rgba(255,255,255,0.35); border-top-color:#fff; border-radius:50%; animation:cu-spin 0.65s linear infinite; }
      @keyframes cu-spin { to { transform:rotate(360deg); } }
    `;
    document.head.appendChild(style);
  }

  function renderUpsellProducts(container, products) {
    if (!products || products.length === 0) { container.closest('.cart-upsell')?.classList.add('hidden'); return; }
    const lang = document.documentElement.lang || '';
    const titleText = lang.startsWith('nl') ? 'Vaak samen gekocht' : lang.startsWith('de') ? 'Andere Besitzer kauften auch' : 'Frequently bought together';

    const slides = products.map((product) => {
      const { price, compare_at_price, variant_id } = getProductPrice(product);
      const priceStr = formatMoney(price);
      const comparePriceStr = compare_at_price && compare_at_price > price
        ? `<span class="cart-upsell__compare-price">${formatMoney(compare_at_price)}</span>` : '';
      const rawImg = product.featured_image;
      const imgSrc = rawImg ? (typeof rawImg === 'string' ? rawImg : (rawImg.src || '')) : (product.images && product.images[0] ? product.images[0] : '');
      const sizedImg = imgSrc ? imgSrc.replace(/(\.[^.?]+)(\?.*)?$/, '_120x120$1$2') : '';
      const imageHTML = sizedImg
        ? `<img class="cart-upsell__image" src="${sizedImg}" alt="${escapeHtml(product.title)}" width="56" height="56" loading="lazy">`
        : `<div class="cart-upsell__image--placeholder"></div>`;
      const productUrl = product.url || `/products/${product.handle}`;
      const actionBtn = variant_id
        ? `<button class="cart-upsell__add-btn" type="button" data-variant-id="${variant_id}" aria-label="Add ${escapeHtml(product.title)} to cart">${PLUS_ICON} ${CART_ICON}</button>`
        : `<a href="${productUrl}" class="cart-upsell__add-btn" style="text-decoration:none;">${PLUS_ICON}</a>`;
      return `<div class="cart-upsell__slide"><div class="cart-upsell__item"><a href="${productUrl}" class="cart-upsell__image-link" tabindex="-1" aria-hidden="true">${imageHTML}</a><div class="cart-upsell__details"><a href="${productUrl}" class="cart-upsell__name" title="${escapeHtml(product.title)}">${escapeHtml(product.title)}</a><div class="cart-upsell__price-row"><span class="cart-upsell__price">${priceStr}</span>${comparePriceStr}</div></div>${actionBtn}</div></div>`;
    }).join('');

    container.innerHTML = `
      <div class="cart-upsell__header">
        <p class="cart-upsell__title">${titleText}</p>
        <div class="cart-upsell__arrows">
          <button class="cart-upsell__arrow cart-upsell__arrow--prev" aria-label="Previous" disabled>${ARROW_PREV}</button>
          <button class="cart-upsell__arrow cart-upsell__arrow--next" aria-label="Next">${ARROW_NEXT}</button>
        </div>
      </div>
      <div class="cart-upsell__swiper">
        <div class="cart-upsell__swiper-wrapper">${slides}</div>
      </div>`;

    container.querySelectorAll('.cart-upsell__add-btn[data-variant-id]').forEach(btn => btn.addEventListener('click', handleAddToCart));
    initSwiper(
      container.querySelector('.cart-upsell__swiper'),
      container.querySelector('.cart-upsell__arrow--prev'),
      container.querySelector('.cart-upsell__arrow--next'),
      products.length
    );
  }

  function initSwiper(el, prevBtn, nextBtn, total) {
    if (!el) return;
    const wrapper = el.querySelector('.cart-upsell__swiper-wrapper');
    if (!wrapper) return;

    let idx = 0, startX = 0, delta = 0, dragging = false;

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx >= total - 1;
    }

    function goTo(i) {
      idx = Math.max(0, Math.min(i, total - 1));
      wrapper.style.transition = 'transform 0.32s cubic-bezier(0.25,0.46,0.45,0.94)';
      wrapper.style.transform = `translateX(-${idx * 85}%)`;
      updateArrows();
    }

    // Arrow clicks
    if (prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); goTo(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); goTo(idx + 1); });

    // Touch
    el.addEventListener('touchstart', e => { startX = e.touches[0].clientX; dragging = true; wrapper.style.transition = 'none'; }, { passive: true });
    el.addEventListener('touchmove', e => {
      if (!dragging) return;
      delta = e.touches[0].clientX - startX;
      const pct = (delta / el.offsetWidth) * 100;
      wrapper.style.transform = `translateX(calc(-${idx * 85}% + ${pct}%))`;
    }, { passive: true });
    el.addEventListener('touchend', () => {
      dragging = false;
      if (delta < -40) goTo(idx + 1);
      else if (delta > 40) goTo(idx - 1);
      else goTo(idx);
      delta = 0;
    });

    // Mouse
    el.addEventListener('mousedown', e => { startX = e.clientX; dragging = true; wrapper.style.transition = 'none'; e.preventDefault(); });
    window.addEventListener('mousemove', e => {
      if (!dragging) return;
      delta = e.clientX - startX;
      const pct = (delta / el.offsetWidth) * 100;
      wrapper.style.transform = `translateX(calc(-${idx * 85}% + ${pct}%))`;
    });
    window.addEventListener('mouseup', () => {
      if (!dragging) return;
      dragging = false;
      if (delta < -40) goTo(idx + 1);
      else if (delta > 40) goTo(idx - 1);
      else goTo(idx);
      delta = 0;
    });

    updateArrows();
  }

  async function handleAddToCart(e) {
    e.stopPropagation();
    const btn = e.currentTarget;
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains('loading') || btn.classList.contains('added')) return;
    btn.classList.add('loading');
    btn.innerHTML = SPINNER;
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cartComp = document.querySelector('cart-items-component[data-drawer]');
      const sectionId = cartComp ? cartComp.dataset.sectionId : null;
      const body = { id: Number(variantId), quantity: 1 };
      if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('cart/add ' + res.status);
      const cartData = await res.json();
      btn.classList.remove('loading');
      btn.classList.add('added');
      btn.innerHTML = CHECK_ICON;
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cartData, sourceId: 'cart-upsell', data: { itemCount: cartData.cart_count || 0, source: 'cart-upsell', sections: cartData.sections || {} } }
      }));
      if (sectionId && cartData.sections && cartData.sections[sectionId] && cartComp) {
        const doc = new DOMParser().parseFromString(cartData.sections[sectionId], 'text/html');
        const newComp = doc.querySelector('cart-items-component[data-drawer]');
        if (newComp) { cartComp.innerHTML = newComp.innerHTML; setTimeout(tryInit, 100); }
      }
      setTimeout(() => { btn.classList.remove('added'); btn.innerHTML = PLUS_ICON; }, 2500);
    } catch (err) {
      console.error('[cart-upsell] add error:', err);
      btn.classList.remove('loading');
      btn.innerHTML = PLUS_ICON;
    }
  }

  async function loadComplementaryProducts(upsellEl) {
    const productId = upsellEl.dataset.productId;
    const inner = upsellEl.querySelector('.cart-upsell__inner');
    if (!productId || !inner) return;
    if (inner.dataset.loadedFor === productId && inner.innerHTML.trim() !== '') return;
    inner.dataset.loadedFor = productId;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = root + 'recommendations/products.json?product_id=' + productId + '&limit=6&intent=related';
    try {
      const res = await fetch(url);
      if (!res.ok) { upsellEl.classList.add('hidden'); return; }
      const data = await res.json();
      const products = (data && data.products) || [];
      if (products.length === 0) { upsellEl.classList.add('hidden'); return; }
      upsellEl.classList.remove('hidden');
      injectStyles();
      renderUpsellProducts(inner, products);
    } catch (err) {
      console.error('[cart-upsell] fetch error:', err);
      delete inner.dataset.loadedFor;
      upsellEl.classList.add('hidden');
    }
  }

  function tryInit() {
    const upsellEl = document.querySelector('#cart-upsell');
    if (!upsellEl) return;
    const inner = upsellEl.querySelector('.cart-upsell__inner');
    if (inner && inner.innerHTML.trim() === '') delete inner.dataset.loadedFor;
    loadComplementaryProducts(upsellEl);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryInit);
  else tryInit();

  document.addEventListener('cart:update', function(e) {
    if (e.detail && e.detail.data && e.detail.data.source === 'cart-upsell') return;
    setTimeout(tryInit, 50);
    setTimeout(tryInit, 300);
    setTimeout(tryInit, 600);
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-testid="cart-drawer-trigger"]')) setTimeout(tryInit, 400);
  });

  new MutationObserver(function(mutations) {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.id === 'cart-upsell') { loadComplementaryProducts(node); return; }
        const found = node.querySelector && node.querySelector('#cart-upsell');
        if (found) { loadComplementaryProducts(found); return; }
      }
      if (m.type === 'childList') {
        const t = m.target;
        const inCartComp = t.tagName === 'CART-ITEMS-COMPONENT' || (t.closest && t.closest('cart-items-component[data-drawer]'));
        if (inCartComp) {
          const upsellEl = document.querySelector('#cart-upsell');
          if (upsellEl) {
            const inner = upsellEl.querySelector('.cart-upsell__inner');
            if (inner && inner.innerHTML.trim() === '') { delete inner.dataset.loadedFor; loadComplementaryProducts(upsellEl); }
          }
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

})();